export default class Blog {
    constructor($el) {
        this.$el = $el;
        this.$body = this.$el.querySelector('.js-blogBody');
        this.$index = this.$el.querySelector('.js-blogIndex');

        this.initIndex();
    }

    initIndex() {
        const $$headers = this.$body.querySelectorAll('h2, h3, h4, h5, h6');
        const $list = document.createElement('ol');

        $$headers.forEach($header => {
            const $listItem = document.createElement('li');
            const $link = document.createElement('a');
            const slug = $header.textContent
                .toLowerCase()
                .trim()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-');
            $link.href = `#${slug}`;
            $link.textContent = $header.textContent;
            $listItem.appendChild($link);
            $list.appendChild($listItem);

            $header.innerHTML = `<a name="${slug}">${$header.textContent}</a>`;
        });

        this.$index.appendChild($list);
    }
}
